import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';
import { GiftIcon, GlobeIcon, FlameIcon, LockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { CountdownTimer } from '../CountdownTimer';
import { CheckList } from '../CheckList';
import { images, offerChecks, offerItems, scarcity } from '../../data/site';
export function Offer() {
  const barRef = useRef<HTMLDivElement>(null);
  const inView = useInView(barRef, {
    once: true
  });
  const [filled, setFilled] = useState(0);
  const pct = Math.round((scarcity.total - scarcity.remaining) / scarcity.total * 100);
  useEffect(() => {
    if (inView) setFilled(pct);
  }, [inView, pct]);
  return <section id="offer" className="bg-ice px-4 py-16 md:px-8 md:py-24" data-id="element-202" data-mp="3nvsh2ikwanen">
      <div className="mx-auto max-w-3xl" data-id="element-203" data-mp="3swghtvyxeim2">
        <div className="mx-auto w-fit rounded-full bg-danger px-4 py-1.5 font-display text-xs font-black uppercase tracking-wide text-white sm:text-sm" data-id="element-204" data-mp="3sxhv873ezh6y">
          Special Digital Release
        </div>
        <h2 className="mt-4 text-center font-display text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-205" data-mp="1kn1g8al4xxi9">
          Everything You’ll Get Today
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-xl ring-1 ring-ice-line" data-id="element-206" data-mp="1bk0boebx4egp">
          <img src={images.mockup} alt="Complete clinical collection" className="mx-auto w-full max-w-lg px-4 pt-6" data-id="element-207" data-mp="16mgyziuvc9qv" />

          <div className="px-5 pb-2 pt-4 sm:px-8" data-id="element-208" data-mp="23aobnn1uvdss">
            <div className="flex items-center justify-between border-b-2 border-navy pb-2 text-[11px] font-black uppercase tracking-wide text-ink-muted" data-id="element-209" data-mp="1zacpg5tuh5f7">
              <span data-id="element-210" data-mp="1ui34l47l6vjs">Your complete clinical collection</span>
              <span data-id="element-211" data-mp="1pl30uzy7m4vu">Value</span>
            </div>
            <ul data-id="element-212" data-mp="1pkb43lsvm13z">
              {offerItems.map(item => <li key={item.name} className={`flex items-start justify-between gap-4 border-b border-ice-line py-3 ${item.highlight ? 'font-bold text-navy' : 'text-ink'}`} data-id="element-213" data-mp="2n0714k2fgnxv">
                  <span className={`flex items-start gap-2 text-[14px] leading-snug ${item.highlight ? 'text-[15px]' : ''} ${!item.highlight && !item.bonus ? 'pl-4 text-ink-muted' : ''}`} data-id="element-214" data-mp="3160odrynegap">
                    {item.bonus && <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" aria-hidden="true" data-id="element-215" data-mp="2scx34xhrgz5i" />}
                    {item.name}
                  </span>
                  <span className={`shrink-0 text-[14px] font-bold ${item.value === 'Included' ? 'text-success' : 'text-ink'}`} data-id="element-216" data-mp="2iepzfgchgdlg">{item.value}</span>
                </li>)}
            </ul>
            <div className="flex items-center justify-between py-4" data-id="element-217" data-mp="29f2y0ujr77se">
              <span className="font-display text-sm font-black uppercase text-ink" data-id="element-218" data-mp="2dfwn3r8xmsmv">Total comparison value</span>
              <span className="font-display text-xl font-black text-danger line-through decoration-2" data-id="element-219" data-mp="7n7r0s8fzrgi">$302</span>
            </div>
          </div>

          <div className="bg-navy px-5 py-8 text-center text-white sm:px-8" data-id="element-220" data-mp="bo00nml87ydb">
            <p className="text-[15px] text-white/75" data-id="element-221" data-mp="1w7lxq7tvscju">
              But you won’t pay <span className="font-bold text-white line-through decoration-danger decoration-2" data-id="element-222" data-mp="1s58srlmykio4">$302</span>. And you won’t pay{' '}
              <span className="font-bold text-white line-through decoration-danger decoration-2" data-id="element-223" data-mp="25x5gzelia8f8">$97</span>.
            </p>
            <p className="mt-4 font-display text-lg font-black uppercase" data-id="element-224" data-mp="214cdsv5or859">Get the complete collection for just</p>
            <p className="font-display text-[84px] font-black leading-none text-gold sm:text-[104px]" data-id="element-225" data-mp="2fwnvhfind1zw">$27</p>
            <p className="mt-2 text-sm font-bold uppercase tracking-wide text-sky" data-id="element-226" data-mp="2axt8s2hk6tai">One-time payment — no monthly fees</p>

            <div className="mx-auto mt-6 max-w-md text-left" data-id="element-227" data-mp="2jvn172c7d2se">
              <CheckList items={offerChecks} tone="dark" data-id="element-228" data-mp="2ju2352qoj1ps" />
            </div>

            <div className="mt-8 flex flex-col items-center gap-5" data-id="element-229" data-mp="uhqjm9pdxejl">
              <CtaButton label="Get the Roadmap for $27" sublabel="Secure checkout · Instant digital access" data-id="element-230" data-mp="pix7olpqxvlj" />
              <CountdownTimer data-id="element-231" data-mp="rvqz9v0cvphu" />
            </div>

            <div ref={barRef} className="mx-auto mt-8 max-w-md text-left" data-id="element-232" data-mp="rz4xqs5wfek0">
              <div className="mb-2 flex items-center justify-between gap-3 text-[13px] font-bold" data-id="element-233" data-mp="vwkmem5z509o">
                <span className="flex items-center gap-1.5 text-gold" data-id="element-234" data-mp="10y9w9yhgn7w6">
                  <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-235" data-mp="15vif81afnfyh" />
                  Only {scarcity.remaining} spots left at the promo price
                </span>
                <span className="text-white/70" data-id="element-236" data-mp="d7mn79vt6c81">{pct}%</span>
              </div>
              <div className="h-4 w-full overflow-hidden rounded-full bg-white/10 ring-1 ring-white/15" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} data-id="element-237" data-mp="d5jlvtp7gwo0">
                <motion.div className="h-full rounded-full bg-danger" initial={{
                width: 0
              }} animate={{
                width: `${filled}%`
              }} transition={{
                duration: 0.9,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-238" data-mp="mzsesii5ermp" />
              </div>
              <p className="mt-2 text-[12px] text-white/60" data-id="element-239" data-mp="3j2i3s540nxhq">When these spots are gone, the price returns to $97.</p>
            </div>

            <div className="mx-auto mt-6 flex max-w-md items-start gap-3 rounded-xl bg-white/5 p-4 text-left ring-1 ring-white/10" data-id="element-240" data-mp="3953rmhp4luv8">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-sky" aria-hidden="true" data-id="element-241" data-mp="344z7mhp0ei09" />
              <p className="text-[13px] leading-snug text-white/80" data-id="element-242" data-mp="304nml3sqifo9">
                <strong className="text-white" data-id="element-243" data-mp="2vdp6a47qxhl0">Automatic currency conversion:</strong> the price is shown in USD and converted automatically to your local currency at checkout.
              </p>
            </div>

            <p className="mt-5 flex items-center justify-center gap-1.5 text-[12px] text-white/60" data-id="element-244" data-mp="2lfrfb8yi56op">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-245" data-mp="2ggy3dkyv5nqn" />
              Secure, encrypted payment
            </p>
          </div>
        </div>
      </div>
    </section>;
}